export default "__VITE_ASSET__Br_AiIZh__"